import { useAuthStore } from '../stores/authStore';

export const useAuth = () => {
  const {
    user,
    token,
    isAuthenticated,
    isLoading,
    isHydrating,
    login,
    register,
    logout,
    updateUser,
    updateSettings,
    completeOnboarding,
  } = useAuthStore();

  return {
    user,
    token,
    isAuthenticated,
    isLoading,
    isHydrating,
    login,
    register,
    logout,
    updateUser,
    updateSettings,
    completeOnboarding,
  };
};
